import { render, staticRenderFns } from "./BlogRow.vue?vue&type=template&id=0fb17314&scoped=true&"
import script from "./BlogRow.vue?vue&type=script&lang=js&"
export * from "./BlogRow.vue?vue&type=script&lang=js&"
import style0 from "./BlogRow.vue?vue&type=style&index=0&id=0fb17314&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fb17314",
  null
  
)

export default component.exports